import { z } from "zod";

/**
 * KHAN-146: esquemas de validacion compartidos.
 *
 * Los formularios de la app validaban cada uno por su cuenta, casi siempre solo
 * con el `required` de HTML, asi que las reglas y los mensajes diferian entre
 * pantallas. Centralizarlos aca hace que "email valido" o "contraseña minima"
 * signifiquen lo mismo en todos lados, y deja un unico lugar donde cambiarlos.
 *
 * Los mensajes van en español porque es el idioma de la interfaz.
 */

// La regla de contraseña se define una sola vez: la usan tanto el registro como
// cualquier formulario futuro que pida una contraseña nueva.
const MIN_PASSWORD_LENGTH = 8;

export const emailField = z
  .string()
  .min(1, "El correo es obligatorio")
  .email("Ingresa un correo valido");

export const requiredText = (label) =>
  z.string().trim().min(1, `${label} es obligatorio`);

export const loginSchema = z.object({
  // En el login NO se valida el largo de la contraseña: las cuentas viejas
  // pueden tener contraseñas mas cortas que la regla actual, y rechazarlas en
  // el cliente dejaria a esos usuarios sin poder entrar. El unico juez de si la
  // contraseña sirve es el backend.
  email: emailField,
  password: z.string().min(1, "La contraseña es obligatoria"),
});

export const signUpSchema = z.object({
  name: requiredText("El nombre"),
  lastname: requiredText("El apellido"),
  email: emailField,
  password: z
    .string()
    .min(
      MIN_PASSWORD_LENGTH,
      `La contraseña debe tener al menos ${MIN_PASSWORD_LENGTH} caracteres`
    ),
});

export const PASSWORD_MIN_LENGTH = MIN_PASSWORD_LENGTH;
